// API OPERATIONS
export const GET_OPTIONS = 'GET_OPTIONS';
export const GET_OPTION = 'GET_OPTION';
export const GET_OPTIONS_FOR_PORTFOLIO = 'GET_OPTIONS_FOR_PORTFOLIO';

// LANDING OPERATIONS
export const SET_ACTIVE_OPTION_TYPE = 'SET_ACTIVE_OPTION_TYPE';
export const SET_ACTIVE_TRAFFIC_TYPE = 'SET_ACTIVE_TRAFFIC_TYPE';
export const SET_ACTIVE_PRODUCT_TYPE = 'SET_ACTIVE_PRODUCT_TYPE';
export const RESET_ACTIVE_OPTION_FILTERS = 'RESET_ACTIVE_OPTION_FILTERS';
export const SET_ACTIVE_OPTIONS = 'SET_ACTIVE_OPTIONS';
export const RESET_ACTIVE_OPTIONS = 'RESET_ACTIVE_OPTIONS';
export const CLEAR_ACTIVE_OPTIONS = 'CLEAR_ACTIVE_OPTIONS';
export const SET_ACTIVE_OPTION_ID = 'SET_ACTIVE_OPTION_ID';
export const RESET_ACTIVE_OPTION_ID = 'RESET_ACTIVE_OPTION_ID';

// WIZARD OPERATIONS
export const OPTION_WIZARD_ADD_OPTION = 'OPTION_WIZARD_ADD_OPTION';
// FORM OPERATIONS
export const UPDATE_OPTION_FORM = 'UPDATE_OPTION_FORM';
export const RESET_OPTION_FORM = 'RESET_OPTION_FORM';

// MISC ?
export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_OPTION = 'SET_OPTION';
export const ADD_OPTION = 'ADD_OPTION';
export const SAVE_OPTION = 'SAVE_OPTION';
export const UPDATE_OPTION = 'UPDATE_OPTION';
export const INSERT_OPTION_TO_STORE = 'INSERT_OPTION_TO_STORE';
export const OPTION_RESET_ALL = 'OPTION_RESET_ALL';
export const OPTION_ERROR = 'OPTION_ERROR';
export const OPTION_CLEAR_ERROR = 'OPTION_CLEAR_ERROR';
export const SET_NEW_OPTION_FLAG = 'SET_NEW_OPTION_FLAG';
export const RESET_IS_SAVED = 'RESET_IS_SAVED';

// MBB FMS
export const SET_MBB = 'SET_MBB';
export const SET_FMS = 'SET_FMS';
